import { Directive, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  standalone: false, selector: '[ngxDisableControl]' })
export class DisableControlDirective {

  @Input() set ngxDisableControl(condition: boolean) {
    const action = condition ? 'disable' : 'enable';
    this.ngControl.control[action]();
  }

  constructor(private ngControl: NgControl) {
  }
}
